<template>
<nav class="navbar navbar-expand-lg navbar-light" id="mainNav">
    <div class="container px-4 px-lg-5">
        <a class="navbar-brand" href="index.html"><img :src="info.image_url"  class="img-fluid rounded-circle" width="100px" alt=""></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavId" aria-controls="collapsibleNavId"
        aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
        </button>
        <div class="collapse navbar-collapse" id="collapsibleNavId">
            <ul class="navbar-nav ms-auto py-4 py-lg-0">
                <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="index.html">Home</a></li>
                <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="about.html">{{info.email}}</a></li>
                <li class="nav-item"><router-link class="nav-link py-3 py-lg-4" to="/login" >Logout</router-link></li>

            </ul>
        </div>
    </div>
 </nav>
 <div class="container" style="margin-top:150px">
     <div class="row">
         <div class="col-md-8 mb-3">
             <div class="card">
                <div class="card-body">
                    <div class="bg-secondary p-2">
                        <img :src="info.image_url" class="rounded-circle" width="100px" alt="">
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-12">
                           <div class="row">
                               <div class="col-md-6 mb-2">First Name: <strong> {{info.firstname}}</strong></div>
                               <div class="col-md-6 mb-3">Last Name: <strong> {{info.lastname}}</strong></div>
                               <div class="col-md-6 mb-2">Email: <strong> {{info.email}}</strong></div>
                               <div class="col-md-6 mb-3">StateOfOrigin: <strong> {{info.state}}</strong></div>
                               <div class="col-md-6 mb-3">L.G.A: <strong> {{info.local}}</strong></div>
                               <div class="col-md-6 mb-4">Phone: <strong> {{info.phone}}</strong></div>
                               <div class="col-md-6 mb-4">Status: <strong> {{info.status}}</strong></div>
                               <div class="col-md-6 mb-4">Parent_Name: <strong> {{info.parent_name}}</strong></div>
                               <div class="col-md-6 mb-4">Parent_Phone: <strong> {{info.parent_number}}</strong></div>
                               <div class="col-md-6 mb-4">NextOfKin: <strong> {{info.parent_name}}</strong></div>

                               <div class="col-md-6 mb-3"><button class="btn btn-secondary btn-edit">Print</button></div>
                           </div>
                        </div>
                    </div>
                </div>
             </div>
         </div>
         <div class="col-md-4">
             <div class="card">
                 <div class="card-body">
                     <h4>Status: <span>{{info.status}}</span></h4>
                 </div>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
import Axios from 'axios'
export default {
    name:'Profile',
    data(){
        return{
            getData:'',
            info:''
        }
    },

    methods:{

    },
    created(){
        let token = localStorage.getItem('potal_data')
        this.getData = JSON.parse(atob(token.split('.')[1]))
        console.log(this.getData.token._id)
        let id = this.getData.token._id
        const URL = `https://stormy-ravine-66505.herokuapp.com/api/user_profile/${id}`
        Axios.get(URL).then(res=>{
            this.info = res.data.response
        }).catch(err => console.log(err))
    },
    mounted(){

    }
}
</script>
<style lang="css" src="../assets/profile.css" scoped></style>